<script>
export default {
  name: "DidoCodeHightlightingShell",
};
</script>

<script setup>
import hljs from "highlight.js/lib/core";
import shell from "highlight.js/lib/languages/shell";
import hljsVuePlugin from "@highlightjs/vue-plugin";

hljs.registerLanguage("shell", shell);
const HighlightJs = hljsVuePlugin.component;

// define Props
const props = defineProps({
  code: { type: String, required: true },
});
</script>

<template>
  <!-- Highlighting code -->
  <HighlightJs language="shell" :code="props.code" />
</template>
